import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

// Define the video-related API endpoints
export const videoApi = createApi({
  reducerPath: "videoApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
  }),
  tagTypes: ["Video", "Videos", "VideosByQuery"],
  endpoints: (builder) => ({
    getVideo: builder.query({
      query: ({ projectId, videoId }) =>
        `video/twelvelabs/${projectId}/${videoId}`,
    }),
    getVideos: builder.query({
      query: ({ projectId, page, pageLimit, filter }) => {
        const params = new URLSearchParams({
          page: page,
          page_limit: pageLimit,
          sort_option: "asc",
        });
        if (filter) {
          params.append("user_metadata", JSON.stringify({ path: filter }));
        }
        return `videos/twelvelabs/${projectId}?${params.toString()}`;
      },
    }),
    getVideosByQuery: builder.mutation({
      query: ({ projectId, query, filter }) => ({
        url: `search`,
        method: "POST",
        body: {
          token: projectId,
          query,
          filter: filter ? { path: filter } : undefined,
        },
      }),
      transformResponse: (response) => {
        // Group segments by video_id and count confidence levels
        const groupedSegments = response.data.reduce((acc, segment) => {
          const { video_id, confidence } = segment;

          if (!acc[video_id]) {
            acc[video_id] = {
              video_id,
              confidenceCounts: {
                high: 0,
                medium: 0,
                low: 0,
              },
              segments: [],
            };
          }

          acc[video_id].confidenceCounts[confidence]++;
          acc[video_id].segments.push(segment);

          return acc;
        }, {});

        // Convert the grouped object into an array
        return {
          ...response,
          data: Object.values(groupedSegments),
        };
      },
    }),
  }),
});

export const {
  useGetVideoQuery,
  useGetVideosQuery,
  useGetVideosByQueryMutation,
} = videoApi;
export default videoApi;
